// 学情
import { sendLogById } from './index'

export default {
  // 页面初始化
  initPageLogger(data) { // 教师ID
    sendLogById('smallfox-teacher_52', {
      ...data
    })
  }
}